import { type ComponentType, lazy } from 'react';

// React.lazy only accepts modules with a default export - this adapts a named export
// so route tables can lazy-load without changing how the source module exports it.
export const lazyNamed = <TModule extends Record<string, unknown>>(
  importModule: () => Promise<TModule>,
  exportName: keyof TModule,
) =>
  lazy(async () => {
    const module = await importModule();
    return { default: module[exportName] as ComponentType };
  });
